<template>
	<div class="wallet">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>直接邀请人数</span>
			<div></div>
		</div>
		<div v-if="tixianlist.length == 0" style="font-size: 12px; color: #999; margin-top: 3.75rem;"> 暂时还未成功邀请~</div>
		<div v-else>
			<div class="source" style="width: 86%; margin: 20px auto; padding: 16px 4%; border-radius: 10px;" v-for="(item,index) in tixianlist"
			 @click="go(item.id)">
				<div class="tieosd">
					<div style="display: flex;">
						<img v-if="item.image == null" src="../../assets/user.png" style="display: block;  width: 2rem; height: 2rem; border-radius: 50%;" />
						<img v-else :src="item.image | handleUrl" style="display: block;  width: 2rem; height: 2rem; border-radius: 50%;" />
						<div style="font-size: 0.9rem; margin-left: 0.4rem; line-height: 2rem;">{{item.username}}</div>
					</div>
					<van-icon size="1rem" name="arrow" style="margin-top: 8px;" />
				</div>
				<div class="tieosd" style="margin-top: 0.625rem;">
					<div style="color: #999999;">联系电话</div>
					<div>{{item.tel}}</div>
				</div>
				<div class="serwme" style="width: 100%; padding: 0; margin: 0;">
					<div class="stjl_s">
						<div>消费笔数</div>
						<span>{{item.user_consumption_count}}</span>
					</div>
					<div class="stjl_s">
						<div>邀请人数</div>
						<span>{{item.user_share}}</span>
					</div>
					<div class="stjl_s">
						<div>收入余额</div>
						<span>{{item.total}}元</span>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				tixianlist: ""
			}
		},
		created() {
			this.getarr();
		},
		methods: {
			getarr() {
				let that = this
				this.$axios.post(baseUrl + '/mobile/user_balance_record/shareCount', {
					user_id: this.$route.query.user_id,
				}).then((res) => {
					that.tixianlist = res.data.data
				}).catch((err) => {
					console.log(err);
				})
			},
			go(e) {
				this.$router.push({
					path: '/invitationnumber',
					query: {
						user_id: e
					}
				})
			},
		},
	}
</script>

<style>
	@import "wallet.css";

	.tieosd {
		display: flex;
		justify-content: space-between;
		margin-bottom: 0.25rem;
	}

	.tieosd>div {
		font-size: 0.8125rem;
	}

	.serwme {
		display: flex;
		justify-content: space-between;
		width: 85%;
		margin: 0.7rem auto;
		text-align: center;
		border-radius: 0.3rem;
		padding: 0px 1rem;
	}

	.stjl_s {
		font-size: 12px;
	}

	.stjl_s div {
		color: #999999;
		margin-top: 4px;
	}

	.stjl_s span {
		margin-top: 4px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/directinvitation.vue